import clsx from 'clsx';

import { numberToLocaleString } from '@atom/utilities/currencyUtility';
import { convertMillisToExactHours } from '@atom/utilities/timeUtilities';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

import { ReportUser } from './reportUtilities';

import classes from './workOrderReport.module.css';

interface Props {
  user: ReportUser;
  showPerDiem: boolean;
  isCompletedOrAbove: boolean;
}

const ReportUserRow = ({ user, showPerDiem, isCompletedOrAbove }: Props) => {
  const getDurationDisplay = () => {
    if (user?.duration) {
      return convertMillisToExactHours(user?.duration);
    }

    if (!user?.duration && isCompletedOrAbove) {
      return '-';
    }

    return '';
  };

  const getPerDiemDisplay = () => {
    if (!isNilOrEmpty(user?.perDiem)) {
      return user?.perDiem.map(item => <div key={item}>{item}</div>);
    }

    if (isNilOrEmpty(user?.perDiem) && isCompletedOrAbove) {
      return '-';
    }

    return '';
  };

  const duration = getDurationDisplay();
  const perDiem = getPerDiemDisplay();

  return (
    <div className={classes.usersTableRow}>
      <div className={classes.usersTableSubRow}>
        <div className={clsx(classes.usersRowCell, classes.name)}>
          {user?.isTeamLead && (
            <span className={classes.teamLead}>&#9733;</span>
          )}
          {user?.name}
        </div>
        <div className={classes.usersRowCell}>{duration}</div>
        {showPerDiem && <div className={classes.usersRowCell}>{perDiem}</div>}
      </div>
      {isCompletedOrAbove && (
        <div className={clsx(classes.usersRowCell, classes.cost)}>
          {numberToLocaleString(user?.actualCost)}
        </div>
      )}
    </div>
  );
};

export default ReportUserRow;
